import React from 'react';
import { connect } from 'react-redux';
import Navigator from '../../../Navigation/Navigator';
import './EndorsementPaymentFailed.scss';

const EndorsementPaymentFailed = () => {
   const handleRetry = () => {
      Navigator.to('/apply-endorsement');
   };

   const handleDashboard = () => {
      Navigator.toDashboard();
   };

   return (
      <div className="section no-pad-bot endorsement-payment-failed-container">
         <div className="container">
            <div className="row">
               <div className="col s12 m8 l6 offset-m2 offset-l3">
                  <div className="failed-card">
                     <div className="failed-icon">
                        <i className="material-icons">error</i>
                     </div>
                     <h4 className="failed-title">Payment Failed</h4>
                     <p className="failed-message">
                        We were unable to process your endorsement application payment.
                     </p>
                     <p className="failed-info">
                        Please check your payment details and try again. If the problem persists, please contact support.
                     </p>
                     <div className="button-container">
                        <button
                           type="button"
                           className="waves-effect waves-light btn btn-secondary"
                           onClick={handleDashboard}
                        >
                           RETURN TO DASHBOARD
                        </button>
                        <button
                           type="button"
                           className="waves-effect waves-light btn btn-ml-30"
                           onClick={handleRetry}
                        >
                           TRY AGAIN
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default connect(null, null)(EndorsementPaymentFailed);